import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class, _class2, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { browserHistory } from 'react-router';
import Helmet from 'react-helmet';
import { initLeadAdBuilder, resetAdBuilderState, createPageLikeAd, createWebsiteClickAd, createLeadGenAd, clearAdBuilderForOrg } from 'redux/modules/adBuilder';
import { AdStep1, AdStep2, AdStep3, ModalLayout, Navbar, LeadFormBuilder } from 'containers';
import { clearAudience } from 'redux/modules/audience';
import { ModalTopBar, Stepper } from 'components';
import { connect } from 'react-redux';
var AdBuilder = (_dec = connect(function (state) {
  var orgId = state.organization.current.id;
  return {
    organization: state.organization.current,
    adType: state.adBuilder ? state.adBuilder.type : null,
    builder: state.adBuilder && state.adBuilder["leadBuilder_".concat(orgId)] ? state.adBuilder["leadBuilder_".concat(orgId)] : null,
    adBuilderState: state.adBuilder,
    formValues: _objectSpread({}, state.adBuilder["".concat(orgId)]),
    facebookAdAccount: state.ads.adAccount && state.ads.adAccount[orgId] ? state.ads.adAccount[orgId] : null,
    type: state.adBuilder["".concat(orgId)] ? state.adBuilder["".concat(orgId)].type : '',
    savedAudiences: state.ads.savedAudiences,
    orgSavedAudiences: state.adsAudiences && state.adsAudiences.savedAudiences && state.adsAudiences.savedAudiences[orgId] ? state.adsAudiences.savedAudiences[orgId] : [],
    slideshowVideoID: state.ads.slideshowVideoID,
    uploadedFacebookVideo: state.ads.uploadedFacebookVideo,
    leadBuilderForm: state.forms["lead_builder_org_".concat(orgId)],
    adAccountConnectedInstagramId: state.adBuilder["".concat(orgId)] ? state.adBuilder["".concat(orgId)].adAccountConnectedInstagramId : null
  };
}, {
  clearAudience: clearAudience,
  initLeadAdBuilder: initLeadAdBuilder,
  resetAdBuilderState: resetAdBuilderState,
  createPageLikeAd: createPageLikeAd,
  createWebsiteClickAd: createWebsiteClickAd,
  createLeadGenAd: createLeadGenAd,
  clearAdBuilderForOrg: clearAdBuilderForOrg
}), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(AdBuilder, _Component);

  var _super = _createSuper(AdBuilder);

  function AdBuilder() {
    var _this;

    _classCallCheck(this, AdBuilder);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      isCreating: false
    });

    _defineProperty(_assertThisInitialized(_this), "confirmBeforeWipingValues", function () {
      if (parseInt(_this.props.params.step, 10) > 1) {
        if (window.confirm('Are you sure you want to leave? You will lose any unsaved changes.')) {
          browserHistory.push("/org/".concat(_this.props.organization.id, "/ads"));
          setTimeout(function () {
            _this.props.resetAdBuilderState(_this.props.organization.id);
          }, 500);
        }
      } else {
        browserHistory.push("/org/".concat(_this.props.organization.id, "/ads"));
        setTimeout(function () {
          _this.props.resetAdBuilderState(_this.props.organization.id);
        }, 500);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleSubmit", function () {
      var socialAccount = _this.props.organization.SocialAccounts.find(function (sa) {
        return _this.props.facebookAdAccount && "".concat(sa.id) === "".concat(_this.props.facebookAdAccount.socialAccountId);
      });

      if (!socialAccount) {
        _this.setState({
          isCreating: false,
          submitError: 'You do not have a Social Account with an Ad Account connected.'
        });

        return console.error('No social account with FB ad account');
      }

      _this.setState({
        isCreating: true,
        submitError: ''
      });

      var _this$props$formValue = _this.props.formValues,
          adName = _this$props$formValue.adName,
          adStart = _this$props$formValue.adStart,
          adEnd = _this$props$formValue.adEnd,
          adBudget = _this$props$formValue.adBudget,
          description = _this$props$formValue.description,
          headline = _this$props$formValue.headline,
          adFormatTabKey = _this$props$formValue.adFormatTabKey,
          linkUrl = _this$props$formValue.linkUrl,
          linkHeadline = _this$props$formValue.linkHeadline,
          call_to_action = _this$props$formValue.call_to_action,
          fromPlannedAd = _this$props$formValue.fromPlannedAd,
          leadFormDescription = _this$props$formValue.leadFormDescription,
          linkDescription = _this$props$formValue.linkDescription,
          videoData = _this$props$formValue.videoData;
      var savedAudience = null;

      if (_this.props.formValues['saved-audiences'] && _this.props.formValues['saved-audiences'].id) {
        var a = [].concat(_toConsumableArray(_this.props.savedAudiences ? _this.props.savedAudiences : []), _toConsumableArray(_this.props.orgSavedAudiences ? _this.props.orgSavedAudiences : []), [_this.props.formValues.reusedAdAudience]).filter(function (b) {
          return b;
        });
        savedAudience = a.find(function (audience) {
          return audience.id === _this.props.formValues['saved-audiences'].id;
        });
      }

      var imageUploads = _this.props.formValues['image-ad-upload'];

      if (adFormatTabKey === 'carousel') {
        imageUploads = _this.props.formValues['carousel-ad-upload'];
      } else if (adFormatTabKey === 'video') {
        imageUploads = [_this.props.uploadedFacebookVideo ? _this.props.uploadedFacebookVideo.videoStill : null, _this.props.formValues.videoData && _this.props.formValues.videoData.image_url ? _this.props.formValues.videoData.image_url : null].filter(function (o) {
          return o;
        });
      }

      var createFunc = function createFunc() {
        return Promise.reject(new Error('Uh-oh! No creation handler for this ad type'));
      };

      if (_this.props.type === 'clicksToWebsite') {
        createFunc = _this.props.createWebsiteClickAd;
      } else if (_this.props.type === 'pageLikes') {
        createFunc = _this.props.createPageLikeAd;
      } else if (_this.props.type === 'leadGeneration') {
        createFunc = _this.props.createLeadGenAd;
      }

      console.log('Creating ad...');
      return createFunc(_this.props.organization.id, socialAccount.id, _objectSpread({
        plannedAdId: fromPlannedAd ? fromPlannedAd.id : null,
        adName: adName,
        adStart: adStart,
        adEnd: adEnd,
        leadFormDescription: leadFormDescription,
        linkDescription: linkDescription,
        instagram: _this.props.adAccountConnectedInstagramId,
        adDescription: description,
        shouldSaveAudience: _this.props.formValues.saveCheckbox,
        adHeadline: linkHeadline || headline,
        images: imageUploads,
        adFormat: adFormatTabKey,
        budget: parseFloat(adBudget) * 100.0,
        link: linkUrl,
        ctaType: call_to_action,
        slideshowVideoID: _this.props.slideshowVideoID ? _this.props.slideshowVideoID.id : _this.props.uploadedFacebookVideo ? _this.props.uploadedFacebookVideo.videoId : _this.props.formValues.videoData && _this.props.formValues.videoData.video_id ? _this.props.formValues.videoData.video_id : null,
        targeting: savedAudience ? _objectSpread({}, savedAudience.FacebookTargetingConfig.data) : {}
      }, _this.props.leadBuilderForm && _this.props.leadBuilderForm.createdForm && _this.props.leadBuilderForm.createdForm.id ? {
        leadFormId: _this.props.leadBuilderForm.createdForm.id
      } : {})).then(function () {
        console.log('Created ad successfully.');

        _this.props.clearAdBuilderForOrg(_this.props.organization.id);

        browserHistory.push("/org/".concat(_this.props.organization.id, "/ads/dashboard"));
      })["catch"](function (err) {
        var errStr = err && err.error ? err.error : '';

        if (errStr.message) {
          errStr = errStr.message;
        }

        if (err.error_user_msg) {
          errStr = err.error_user_msg;
        }

        _this.setState({
          isCreating: false,
          submitError: errStr.toString()
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderStepper", function (step) {
      var steps = [{
        link: "/org/".concat(_this.props.organization.id, "/create-ad/1"),
        label: 'Select Ad Goal'
      }, {
        link: "/org/".concat(_this.props.organization.id, "/create-ad/2"),
        label: 'Ad Settings'
      }, {
        link: "/org/".concat(_this.props.organization.id, "/create-ad/3"),
        label: 'Create Ad'
      }];
      return /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          flex: '1 1 auto',
          justifyContent: 'center'
        }
      }, /*#__PURE__*/React.createElement(Stepper, {
        steps: steps,
        currentStep: step,
        clickableSteps: true
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "renderView", function () {
      var _this$props = _this.props,
          adType = _this$props.adType,
          type = _this$props.type,
          orgId = _this$props.params.organizationId;
      var step = parseInt(_this.props.params.step, 10);
      console.log('adType = ', _this.props.type);
      var adTypeText = '';

      switch (type) {
        case 'clicksToWebsite':
          adTypeText = 'Website Click Ad';
          break;

        case 'leadGeneration':
          adTypeText = 'Lead Generation Ad';
          break;

        default:
          adTypeText = 'Page Like Ad';
      }

      switch (step) {
        // Page 1 is covered by default case
        case 2:
          return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ModalTopBar, {
            onPrimaryButtonClick: _this.props.onPrimaryButtonClick,
            adScreen: true,
            innerStuff: _this.renderStepper(2),
            handleClose: _this.confirmBeforeWipingValues,
            handleGoBack: function handleGoBack() {
              return browserHistory.push("/org/".concat(_this.props.organization.id, "/create-ad/1"));
            }
          }), /*#__PURE__*/React.createElement("div", {
            className: "container-fluid",
            style: {
              height: '100%',
              maxWidth: '1300px'
            }
          }, /*#__PURE__*/React.createElement(AdStep2, {
            adTypeText: adTypeText,
            form: "adForm_".concat(orgId)
          })));

        case 3:
          return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ModalTopBar, {
            onPrimaryButtonClick: _this.props.onPrimaryButtonClick,
            adScreen: true,
            innerStuff: _this.renderStepper(3),
            handleClose: _this.confirmBeforeWipingValues,
            handleGoBack: function handleGoBack() {
              return browserHistory.push("/org/".concat(_this.props.organization.id, "/create-ad/2"));
            }
          }), /*#__PURE__*/React.createElement("div", {
            className: "container-fluid",
            style: {
              height: '100%',
              maxWidth: '1300px'
            }
          }, /*#__PURE__*/React.createElement(AdStep3, {
            adTypeText: adTypeText,
            isCreatingAd: _this.state.isCreating,
            onSubmit: _this.handleSubmit,
            form: "adForm_".concat(orgId)
          })));

        default:
          return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ModalTopBar, {
            onPrimaryButtonClick: _this.props.onPrimaryButtonClick,
            adScreen: true,
            innerStuff: _this.renderStepper(1),
            handleClose: _this.confirmBeforeWipingValues,
            handleGoBack: _this.confirmBeforeWipingValues
          }), /*#__PURE__*/React.createElement("div", {
            className: "container-fluid",
            style: {
              height: '100%'
            }
          }, /*#__PURE__*/React.createElement(AdStep1, {
            form: "adForm_".concat(orgId)
          })));
      }
    });

    return _this;
  }

  _createClass(AdBuilder, [{
    key: "UNSAFE_componentWillMount",
    value:
    /** *********************************************************
     LIFECYCLE METHODS
     ***********************************************************/
    function UNSAFE_componentWillMount() {
      if (!this.props.builder) {
        this.props.initLeadAdBuilder(this.props.organization.id);
      }
    }
    /** *********************************************************
     EVENT HANDLERS
     ***********************************************************/

  }, {
    key: "render",
    value: function render() {
      var isModal = this.props.isModal;
      var step = parseInt(this.props.params.step, 10);
      var nonModalView = /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Navbar, {
        position: "fixed",
        text: "Likeable",
        params: _objectSpread({}, this.props.params)
      }), /*#__PURE__*/React.createElement(ModalTopBar, {
        onPrimaryButtonClick: this.props.onPrimaryButtonClick,
        adScreen: true,
        innerStuff: this.renderStepper(step),
        handleClose: this.confirmBeforeWipingValues
      }), /*#__PURE__*/React.createElement(ModalLayout, {
        childrenWrapStyle: {
          overflow: 'hidden'
        }
      }, this.renderView()));
      return /*#__PURE__*/React.createElement("div", {
        style: {
          height: '100%'
        }
      }, /*#__PURE__*/React.createElement(Helmet, {
        title: "Ad Builder"
      }), isModal ? this.renderView() : nonModalView);
    }
  }]);

  return AdBuilder;
}(Component), _defineProperty(_class2, "propTypes", {
  params: PropTypes.object.isRequired,
  onPrimaryButtonClick: PropTypes.object,
  isModal: PropTypes.bool
}), _temp)) || _class);
export default AdBuilder;